import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const PRIMARY_COLOR = '#29626b';

export default function initNavbarScroll() {
	const navbar = document.querySelector('.navbar');
	const desktopLogo = document.querySelector('#main-menu .menu-item.logo .nav-logo');

	if (!navbar) return;

	// Start navbar transparent
	gsap.set(navbar, { backgroundColor: 'transparent' });

	// Fade background in to $primary over first 200px of scroll
	gsap.to(navbar, {
		backgroundColor: PRIMARY_COLOR,
		ease: 'none',
		scrollTrigger: {
			start: 0,
			end: 200,
			scrub: true,
		}
	});

	// Scale desktop logo and remove left offset over same scroll distance
	if (desktopLogo) {
		gsap.to(desktopLogo, {
			height: '6rem',
			ease: 'none',
			scrollTrigger: {
				start: 0,
				end: 200,
				scrub: true,
			}
		});
	}

	// Shrink the logo menu item width and remove left offset on scroll
	const logoMenuItem = document.querySelector('.navbar-nav .menu-item.logo');
	if (logoMenuItem) {
		gsap.to(logoMenuItem, {
			width: '8rem',
			left: 0,
			ease: 'none',
			scrollTrigger: {
				start: 0,
				end: 200,
				scrub: true,
			}
		});
	}
}
